/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:787bea25-b3f2-478b-aee8-aa9c3b6ad580",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_W1eqI99A6",
    "aws_user_pools_web_client_id": "3r2o3in3d0pq0bavpptvupsrfc",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://5u5o2uyh8f.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
